import { Button, Dialog, DialogContent } from '@material-ui/core'
import { ChevronLeft } from '@material-ui/icons'
import MediaDetail from './MediaDetail'
import { useStyles } from '@webapps/styles';

const ModalMedia = ({ closeMediaModal, openMedia, data, imageInfo, info, swipIndex }) => {

  const { classes, css } = useStyles(styles);

  return (
    <Dialog
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(0, 45, 117, 0.6)',
        },
      }}
      classes={{
        paperScrollPaper: css({
          width: '100%',
          maxHeight: 'max-content',
          maxWidth: 800,
          position: 'relative',
          overflow: 'visible',
          height: '100%',
          borderRadius: 0,
          '@media (max-width:768px)': { margin: 0 }
        }),
      }}
      onClose={closeMediaModal}
      open={openMedia}
    >
      <DialogContent style={{ height: '100%' }}>
        <Button
          className={classes.returnButton}
          onClick={closeMediaModal}
          startIcon={<ChevronLeft />}
        >
          Retour
        </Button>
        <MediaDetail
          Data={data}
          image={imageInfo}
          infoVitrine={info}
          swipIndex={swipIndex}
        />
      </DialogContent>
    </Dialog>
  )
}

const styles = ({ fontSizes, spacing }) => ({
  returnButton: {
    color: '#5A6DA1',
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    border: '1px solid #C0D9FF',
    backgroundColor: 'white',
    borderRadius: '20px',
    width: '130px',
    fontWeight: 600,
    marginBottom: spacing(5),
    marginBottom: spacing(2)
  },
});

export default ModalMedia